export default __webpack_public_path__ + "static/media/F5687K-min.7e8c84be.jpg";